import VoucherItem from './VoucherItem';
import VoucherListView from './VoucherListView';

export default {
  Item: VoucherItem,
  ListView: VoucherListView
};
